import { WrapperLayout } from "layouts/WrapperLayout";
import { Outlet } from "react-router-dom";

const DefaultLayout = () => {
  return (
    <WrapperLayout>
      <div className="main-content">
        <Outlet />
      </div>
    </WrapperLayout>
  );
};

export default DefaultLayout;
